<app-formular [formBuilderInput]="overviewForm" [formular]="overviewFormular"></app-formular>
<br>
<button mat-raised-button *ngIf="router.url != '/gipReqOverview'" (click)="submit()"
  [disabled]="disableSubmitButton">{{"btn_SubmitRequest" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
  <div>
    <button mat-raised-button [disabled]="disableSubmitButton" matStepperPrevious>{{"btn_back" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
</div>